import React, { useMemo } from 'react';
import { useFocusIdx } from 'easy-email-editor';
import { SelectField } from '../../../components/Form';

const options = [
  {
    value: 'initial',
    label: 'нет',
  },
  {
    value: 'uppercase',
    label: 'верхний регистр',
  },
  {
    value: 'lowercase',
    label: 'нижний регистр',
  },
  {
    value: 'capitalize',
    label: 'капитализировать',
  },
];

export function TextTransform({ name }: { name?: string; }) {
  const { focusIdx } = useFocusIdx();

  return useMemo(() => {
    return (
      <SelectField
        label='Преобразование текста'
        name={name || `${focusIdx}.attributes.text-transform`}
        options={options}
      />
    );
  }, [focusIdx, name]);
}
